import { useEffect, useState } from "react";
import { parseApiError } from "../utils/api-error";
import { errorMsg } from "../utils/toast-msg";

// Runs `fetcher` whenever `deps` change and tracks { data, loading }.
// Stale responses are ignored and failures surface as a toast.
export default function useFetch(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    setLoading(true);

    fetcher()
      .then((result) => {
        if (!ignore) setData(result);
      })
      .catch((error) => {
        if (!ignore) errorMsg(parseApiError(error).generalMessage);
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });

    return () => {
      ignore = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading };
}
